export default "https://assets.pclncdn.com/web/next-landing/8f5502c/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";